import { match } from "ts-pattern";

import { ApiClient } from "../../../lib/api-client";
import { EdgeDevice } from "../domain";

export class MonitoringUnavailableError extends Error {
  hasAgents: boolean;
  hasMeasuringDevicesPromise: Promise<boolean>;
  hasProsumersInEnergySystem: boolean;

  constructor(
    hasAgents: boolean,
    hasMeasuringDevices: Promise<boolean>,
    hasProsumersInEnergySystem: boolean
  ) {
    super("MonitoringFallbackError");
    this.name = "MonitoringFallbackError";
    this.hasAgents = hasAgents;
    this.hasMeasuringDevicesPromise = hasMeasuringDevices;
    this.hasProsumersInEnergySystem = hasProsumersInEnergySystem;
  }
}

export async function throwMonitoringUnavailableError(apiClient: ApiClient) {
  const hasMeasuringDevicesPromise = apiClient
    .getMeasuringDevices(7000)
    .then((devices) => devices.length > 0);

  const [edgeDevices, prosumers] = await Promise.all([
    apiClient.getEdgeDevices(),
    apiClient.getProsumers(),
  ]);

  throw new MonitoringUnavailableError(
    edgeDevices.some(function (edgeDevice: EdgeDevice): boolean {
      return match(edgeDevice.type)
        .with("agent1", "agent2", () => true)
        .exhaustive(() => false);
    }),
    hasMeasuringDevicesPromise,
    prosumers.length > 0
  );
}
